import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IfPermDirective } from './directives/if-permision.directive';

import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TypeUseItemPipe } from './pipes/type-use-item.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [TypeUseItemPipe, SafeHtmlPipe, IfPermDirective],
  exports: [TypeUseItemPipe, SafeHtmlPipe, IfPermDirective],
})
export class SharedModule {}
